import localhost from "apis/localhost";
import { CHUNK_SIZE } from "components/Modal/ChooseFilesModal/utils";
import {
  COLLECTION_CHUNK_URL,
  DOCUMENT_CHUNK_URL,
  STYLE_TEMPLATES_CHUNK_URL,
  UPLOAD_ENTITY_TYPES,
} from "constants/documentUploads";

const calculateChunkMetadata = (file) => {
  const totalChunks = Math.ceil(file.content.size / CHUNK_SIZE);
  const chunks = [];

  for (let i = 0; i < totalChunks; i++) {
    const start = i * CHUNK_SIZE;
    const end = Math.min(start + CHUNK_SIZE, file.content.size);

    chunks.push({
      index: i,
      start,
      end,
    });
  }
  return { totalChunks, chunks };
};

const getUrlByTarget = (target) => {
  switch (target) {
    case UPLOAD_ENTITY_TYPES.COLLECTIONS:
      return COLLECTION_CHUNK_URL;
    case UPLOAD_ENTITY_TYPES.DOC_STYLE_TEMPLATES:
      return STYLE_TEMPLATES_CHUNK_URL;
    default:
      return DOCUMENT_CHUNK_URL;
  }
};

export const uploadChunk = async (
  file,
  chunk,
  chunkIndex,
  metadata,
  target
) => {
  const formData = new FormData();
  formData.append("file", chunk);
  formData.append("fileHash", file.hash);
  formData.append("fileName", file.content.name);
  formData.append("chunkIndex", chunkIndex);
  formData.append("fileUploadId", file.fileUploadId);

  if (target === UPLOAD_ENTITY_TYPES.COLLECTIONS) {
    formData.append("ragDocumentId", file.ragDocumentId);
  }

  Object.entries(metadata).forEach(([key, value]) => {
    formData.append(key, value);
  });

  const url = getUrlByTarget(target);

  try {
    const response = await localhost.post(url, formData);
    if (response.status !== 200) {
      throw new Error(`Upload failed: ${response.statusText}`);
    }
  } catch (error) {
    console.error("Chunk upload error:", error);
  }
};

export const uploadFiles = async (files, metadata, target) => {
  for (const file of files) {
    const { chunks } = calculateChunkMetadata(file);
    for (const chunk of chunks) {
      const start = chunk.start;
      const end = chunk.end;
      const chunkBlob = file.content.slice(start, end);

      await uploadChunk(file, chunkBlob, chunk.index, metadata, target);
    }
  }
};
